import Validate from './validate'
import { remBase } from '@const/env'
import { Message } from 'element-ui'

/**
 * 异步加载资源文件
 *
 * @param {*} page
 */
export const newImport = (page) => {
  // import参数不能直接是变量
  return import(/* webpackChunkName: "[request]" */ '@pages/' + page).catch(
    (error) => {
      console.log('加载资源失败', error, page)
      Message({
        message: '页面加载失败,重新加载中',
        duration: 3000,
        onClose: () => {
          window.location.href = '/'
        }
      })
    }
  )
}

/**
 * 获取链接指定参数
 * @param key
 * @returns {*}
 */
export function getParamsByName(key) {
  let thisURL = window.location.href
  let params = thisURL.split('?')
  if (Validate.isNull(params[1])) {
    /*参数为空*/
    return null
  }
  params[1] = decodeURIComponent(params[1])
  let args = params[1].split('&')
  for (let i = 0; i < args.length; i++) {
    let str = args[i]
    let arg = str.split('=')
    if (arg.length <= 1) {
      continue
    }

    if (arg[0] === key) {
      return arg[1]
    }
  }
  return null
}

export function genRandom(length) {
  var result = ''
  var characters =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789'
  var charactersLength = characters.length
  for (var i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength))
  }
  return result
}

/**
 * h5拍照
 * @param change callback
 */
export function TakePhoto(change) {
  let input = document.createElement('input')
  input.style.display = 'none'
  input.type = 'file'
  input.accept = 'image/*'
  document.body.append(input)
  input.onchange = (e) => {
    if (change && typeof change === 'function') {
      change(e.target.files[0])
    }
  }
  input.click()
}

export function pxToRem(value) {
  return (value / remBase()).toFixed(4) + 'rem'
}

export function getAge(identityCard) {
  let len = (identityCard + '').length
  let strBirthday = ''
  if (len == 18) {
    //处理18位的身份证号码从号码中得到生日和性别代码
    strBirthday =
      identityCard.substr(6, 4) +
      '/' +
      identityCard.substr(10, 2) +
      '/' +
      identityCard.substr(12, 2)
  }
  if (len == 15) {
    let birthdayValue = ''
    birthdayValue = identityCard.charAt(6) + identityCard.charAt(7)
    if (parseInt(birthdayValue) < 10) {
      strBirthday =
        '20' +
        identityCard.substr(6, 2) +
        '/' +
        identityCard.substr(8, 2) +
        '/' +
        identityCard.substr(10, 2)
    } else {
      strBirthday =
        '19' +
        identityCard.substr(6, 2) +
        '/' +
        identityCard.substr(8, 2) +
        '/' +
        identityCard.substr(10, 2)
    }
  }
  let birthDate = new Date(strBirthday)
  let nowDateTime = new Date()
  let age = nowDateTime.getFullYear() - birthDate.getFullYear()
  //再考虑月、天的因素;.getMonth()获取的是从0开始的，这里进行比较，不需要加1
  if (
    nowDateTime.getMonth() < birthDate.getMonth() ||
    (nowDateTime.getMonth() == birthDate.getMonth() &&
      nowDateTime.getDate() < birthDate.getDate())
  ) {
    age--
  }
  return age
}



// WEBPACK FOOTER //
// ./src/utils/common.js